export const SENTRY_RELEASE: string | undefined = 'a64065687e41e3acb3d38f11dd4a6173464c091b';
